import {nFormatter, createSeries, seriesHead, appendAggregateValues, seriesDataItem, getData, resolve, applyChartParameters} from "@/components/charts/common";
import echarts from 'echarts/'

export default async function hydrator(parameters, _data, chart) {
  let jData = await getData(chart, parameters);
  // console.log('jData', jData);

  let itemStyle = {
    opacity: 0.8,
    shadowBlur: 10,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: 'rgba(0, 0, 0, 0.5)'
  };

  chart.render = false;
  // chart.overlayContent = "";
  applyChartParameters(chart, parameters);
  chart.chartData = {series: []};


  let dynamicOptions = {};

  dynamicOptions.title = resolve("title.value", parameters, "");
  dynamicOptions.xAxisLabel = resolve("xAxisLabel.value", parameters, "X Axis Label");
  dynamicOptions.yAxisLabel = resolve("yAxisLabel.value", parameters, "Y Axis Label");
  dynamicOptions.backgroundColor = resolve("backgroundColor.value", parameters, "#404a59");
  dynamicOptions.color = resolve("color.value", parameters, "#ccc");
  dynamicOptions.timelineColor = resolve("timelineColor.value", parameters, "rgba(255, 255, 255, 0.7)");
  dynamicOptions.size = resolve("size.value", parameters, 80);
  dynamicOptions.speed = resolve("speed.value", parameters, 1000);

  dynamicOptions.timelineTitleSize = resolve("timelineTitleSize.value", parameters, 80);
  dynamicOptions.timelineTitleColor = resolve("timelineTitleColor.value", parameters, '#424242');
  dynamicOptions.timelineTitleTop = resolve("timelineTitleTop.value", parameters, '10%');
  dynamicOptions.timelineTitleLeft = resolve("timelineTitleLeft.value", parameters, '70%');

  dynamicOptions.axisLineColor = resolve("axisLineColor.value", parameters, "#ccc");
  dynamicOptions.axisFontColor = resolve("axisFontColor.value", parameters, "#ccc");

  dynamicOptions.realtime = resolve("cacheable.value", parameters, false);

  dynamicOptions.symbol = resolve("symbol.value", parameters, 'circle');
  dynamicOptions.labelPosition = resolve("labelPosition.value", parameters, 'inside');
  dynamicOptions.labelFontSize = resolve("labelFontSize.value", parameters, 12);

  if(dynamicOptions.symbol && dynamicOptions.symbol.includes("http")) {
    dynamicOptions.symbol = 'image://' + dynamicOptions.symbol;
  }



  dynamicOptions.colors = resolve("colors.value", parameters, "#bcd3bb,#e88f70,#edc1a5,#9dc5c8,#e1e8c8,#7b7c68,#e5b5b5,#f0b489,#928ea8,#bda29a");
  console.log("dynamicOptions.symbol", dynamicOptions.symbol);

  dynamicOptions.fontFamily = "Roboto,sans-serif";


  const categories = [...new Set(jData.map(item => item.category))];
  const timelines = [...new Set(jData.map(item => item.timeline))];

  // console.log("categories", categories);
  // console.log("timelines", timelines);

  let kData = {};

  let maxX = 0;
  let maxY = 0;
  let maxSize = 1;
  for(let i = 0; i < jData.length; i++) {
    let row = jData[i];
    if(typeof kData[row.timeline] == "undefined") {
      kData[row.timeline] = [];
    }
    if(row.x > maxX) {
      maxX = row.x;
    }
    if(row.y > maxY) {
      maxY = row.y;
    }
    if(row.size > maxSize) {
      maxSize = row.size;
    }
    kData[row.timeline].push([row.x, row.y, row.size, row.category, row.timeline, row.description, row]);
  }

  // console.log("maxY", maxY);
  // console.log("maxX", maxX);
  // console.log("maxSize", maxSize);

  let sizeFunction = function (x) {
    var y = Math.sqrt(x / maxSize) + 0.1;
    return y * dynamicOptions.size;
  };



  let option = {
    baseOption: {
      timeline: {
        axisType: 'category',
        orient: 'vertical',
        autoPlay: true,
        inverse: true,
        playInterval: dynamicOptions.speed,
        left: null,
        right: 0,
        top: 20,
        bottom: 20,
        width: 55,
        height: null,
        label: {
          color: dynamicOptions.timelineColor
        },
        symbol: 'none',
        lineStyle: {
          color: dynamicOptions.timelineColor
        },
        checkpointStyle: {
          color: dynamicOptions.timelineColor,
          borderColor: dynamicOptions.timelineColor,
          borderWidth: 2
        },
        controlStyle: {
          showNextBtn: false,
          showPrevBtn: false,
          color: dynamicOptions.timelineColor,
          borderColor: dynamicOptions.timelineColor
        },
        emphasis: {
          label: {
            color: dynamicOptions.color
          },
          controlStyle: {
            color: dynamicOptions.timelineColor,
            borderColor: dynamicOptions.timelineColor
          }
        },
        data: []
      },
      backgroundColor: dynamicOptions.backgroundColor,
      title: [{
        text: timelines[0],
        textAlign: 'left',
        left: dynamicOptions.timelineTitleLeft,
        top: dynamicOptions.timelineTitleTop,
        textStyle: {
          fontFamily: dynamicOptions.fontFamily,
          fontSize: dynamicOptions.timelineTitleSize,
          color: dynamicOptions.timelineTitleColor
        }
      },
      {
        text: dynamicOptions.title,
        left: 'center',
        top: 10,
        textStyle: {
          fontFamily: dynamicOptions.fontFamily,
          color: '#aaa',
          fontWeight: 'normal',
          fontSize: dynamicOptions.labelFontSize
        }
      }],
      tooltip: {
        padding: 5,
        backgroundColor: '#222',
        borderColor: '#777',
        borderWidth: 1,
        formatter: function (obj) {
          var value = obj.value;
          return value[5];
        }
      },
      grid: {
        top: 100,
        containLabel: true,
        left: 30,
        right: '110'
      },
      xAxis: {
        type: 'value',
        name: dynamicOptions.xAxisLabel,
        max: maxX,
        min: 0,
        nameGap: 25,
        nameLocation: 'middle',
        nameTextStyle: {
          fontFamily: dynamicOptions.fontFamily,
          color: dynamicOptions.axisFontColor,
          fontSize: 18
        },
        splitLine: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: dynamicOptions.axisLineColor
          }
        },
        axisLabel: {
          formatter: '{value} '
        }
      },
      yAxis: {
        type: 'value',
        name: dynamicOptions.yAxisLabel,
        max: maxY,
        nameTextStyle: {
          fontFamily: dynamicOptions.fontFamily,
          color: dynamicOptions.axisFontColor,
          fontSize: 18
        },
        axisLine: {
          lineStyle: {
            color: dynamicOptions.axisLineColor
          }
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          formatter: '{value} '
        }
      },
      visualMap: [
        {
          show: false,
          dimension: 3,
          categories: categories,
          calculable: true,
          precision: 0.1,
          textGap: 30,
          textStyle: {
            fontFamily: dynamicOptions.fontFamily,
            color: '#ccc'
          },
          inRange: {
            color: (function () {
              var colors = dynamicOptions.colors.split(",");
              return colors.concat(colors);
            })()
          }
        }
      ],
      series: [
        {
          label: {
            position: dynamicOptions.labelPosition,
            fontFamily: dynamicOptions.fontFamily,
            fontSize: '25',
            show: true,
            formatter: function(d) {
              return d.value[3];
            }
          },
          type: 'scatter',
          itemStyle: itemStyle,
          data: kData[timelines[0]],
          symbol: dynamicOptions.symbol,
          symbolFuncDontWork: function(value, params) {
            console.log('dynamicOptions.symbol', dynamicOptions.symbol);
            if(dynamicOptions.symbol == 'circle' || dynamicOptions.symbol) {
              return 'circle';
            } else if(dynamicOptions.symbol.trim()) {
              return 'image://' + dynamicOptions.symbol.trim();
            }
            return 'circle';
          },
          symbolSize: function(val) {
            return sizeFunction(val[2]);
          }
        }
      ],
      animationDurationUpdate: dynamicOptions.speed,
      animationEasingUpdate: 'linear'
    },
    options: []
  };

  for (var n = 0; n < timelines.length; n++) {
        option.baseOption.timeline.data.push(timelines[n]);
        option.options.push({
            title: {
                show: true,
                'text': timelines[n] + ''
            },
            series: {
                name: timelines[n],
                type: 'scatter',
                itemStyle: itemStyle,
                data: kData[timelines[n]],
                symbolSize: function(val) {
                    return sizeFunction(val[2]);
                }
            }
        });
    }

    chart.options = option;





    chart.chartData.series = categories;




    chart.draw = function() {
    if (typeof chart.refs != "undefined") {

      try {
        chart.thisEChart.clear();
      } catch(err) {

      }

      if(typeof chart.uiLoaded == "undefined") {
        chart.uiLoaded = false;
      }

      if(typeof chart.thisEChart == "undefined" || chart.uiLoaded) {
        chart.thisEChart = echarts.init(chart.refs.echart);
        chart.uiLoaded = true;
      } else {
        chart.thisEChart = echarts.init(chart.refs.echart);
      }

      chart.thisEChart.setOption(chart.options);


      chart.thisEChart.on("timelinechanged", function(data) {
        // console.log("timelinechanged", data);
        // console.log(kData[timelines[data.currentIndex]]);

        const rows = kData[timelines[data.currentIndex]];

        chart.overlayContent = "";
        for(let i = 0; i < rows.length; i++) {
          const row = {...rows[i][6]};
          if(typeof row.overlay_content != "undefined" && row.overlay_content) {
            // console.log(row);
            chart.overlayContent += row.overlay_content;
          }
        }

        if(chart.overlayContent.trim()) {
          //console.log("chart.overlayContent", chart.overlayContent);
          //console.log(chart);
        } else {
          chart.overlayContent = "";
        }

        // chart.setOverlayContent(chart.chartData.overlayContent);

        // chart.layerReference.overlayContent = chart.parameters.overlayContent;

      });





      chart.thisEChart.on("timelineplaychanged", function(data) {
        // console.log("timelineplaychanged", data);
      });




    }

    // chart.chartData

  }

  chart.render = true;
  if (typeof chart.refs != "undefined") {
    chart.draw();
  }


}
